import React from 'react';
interface ServiceCardProps {
  number: string;
  title: string;
  description: string;
  outcomes: string;
  examples: string;
}
export function ServiceCard({
  number,
  title,
  description,
  outcomes,
  examples
}: ServiceCardProps) {
  return <div className="card transition-transform duration-200 hover:-translate-y-1" data-id="element-154">
      <span className="text-5xl font-extrabold text-blue-600" data-id="element-155">{number}</span>
      <h3 className="mt-4 text-2xl font-bold text-slate-900" data-id="element-156">{title}</h3>
      <p className="mt-2 text-slate-600" data-id="element-157">{description}</p>
      <div className="mt-4 pt-4 border-t border-slate-200" data-id="element-158">
        <strong className="text-slate-900" data-id="element-159">Outcomes:</strong>
        <p className="text-slate-600" data-id="element-160">{outcomes}</p>
        <strong className="text-slate-900 mt-2 block" data-id="element-161">Examples:</strong>
        <p className="text-slate-600" data-id="element-162">{examples}</p>
      </div>
    </div>;
}